export default __webpack_public_path__ + "static/media/i3pay.bc9efeb3.ico";